const LoginHeader = () => {
  return (
    <div className="login--header-outer">
      <div className="login--header" />
    </div>
  );
};

export default LoginHeader;
